import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';

@Component({
    selector: 'app-delete-tag',
    templateUrl: './delete-tag.component.html',
    styleUrls: ['./delete-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteTagComponent implements OnInit {

  @Input() deleteTag: any;
  tag_id: any;
  tag_name: any;
  tag_color: any;
  loading: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private reportService: ReportsService,
    private sweetAlertService: SweetAlertService,
  ) { }

  ngOnInit(): void {
    if (this.deleteTag && this.deleteTag.getDeleteTag) {
      this.tag_id = this.deleteTag.getDeleteTag.tag_id;
      this.tag_name = this.deleteTag.getDeleteTag.tag_name;
      this.tag_color = this.deleteTag.getDeleteTag.tag_color;
    }
    // console.log(this.tag_id);
    // console.log(this.tag_name);
    // console.log(this.tag_color);
  }

  closeModel(): void {
    this.activeModal.dismiss();
  }

  getDeleteTag(){
    this.loading = true;
    const formData: any = new FormData();
    formData.append('tag_name',this.tag_name);
    formData.append('tag_color', this.tag_color);
    formData.append('tag_id', this.tag_id);
    formData.append('delete_tag', 'delete_tag');
    this.reportService.getTagsCreate(formData).subscribe({
      next: (data) => {
        this.loading = false;
        if (data == "error") {
          this.sweetAlertService.sweetAlert("error", "Error in deleting");
        }
        else if (data == "success") {
          this.sweetAlertService.sweetAlert("success", "Tag deleted successfully");
          this.activeModal.dismiss('success');
        }
      },
      error: () => {
        this.loading = false;
      }
    })
  }

}
